import './FirmwaresList.scss'
import List from './List'

export default function Dashboard({ data }) {

    return (
        <div className='firmwares_list'>
            <div className='firmwares_list_header' >
                <p>ID </p>
                <p>Device Type </p>
                <p>HW Version </p>
                <p>SW Version </p>
                <p>Uploaded At</p>
            </div>
            <div>
                {
                    data.map((value, index) => {
                        return (
                            <List
                                key={index}
                                id={value.id}
                                details={'Details'}
                                {...value}
                            />
                        )
                    })
                }

            </div>

        </div>
    )
}
